<template>
  <div class="address-filial-info-component">
    <div class="address-filial-info">
      <div v-if="loading" class="text-center">
        Проверяем адрес...
      </div>
      <!--      <loader class="address-filial-info-loader" v-if="loading" />-->
      <div v-else-if="errorText" class="address-filial-info-error">
        <span>
          <font-awesome-icon icon="exclamation-triangle" />
          {{ errorText }}
        </span>
        <v-btn
          class="choose-coordinates-btn"
          depressed
          color="success"
          large
          @click="$emit('choose-coordinates')"
        >
          Указать координаты на карте
        </v-btn>
      </div>
      <div v-else-if="!info" class="address-filial-info-hint">
        Для определения филиала укажите город, улицу и дом...
      </div>
      <template v-else>
        <div class="address-filial-info-block">
          <div class="address-filial-info-label">
            {{ polygonInfoLabel }}, {{ polygonDeliveryTime }} от {{ polygonMinAmount | amountWithCurrency }}
          </div>

          <work-time-label
            class="address-filial-info-work-time"
            :start-time="getFilialStartTime"
            :end-time="getFilialEndTime"
            :time-zone="getFilialTimeZone"
          />

          <span v-if="filialIsNotConnected" class="address-filial-info-alert">
            не подключен к FAKT
          </span>

          <v-tooltip
            v-if="polygonTooltipInfo"
            bottom
            close-delay="500"
            open-on-click
          >
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                class="polygon-info-icon"
                v-on="on"
              >
                <font-awesome-icon icon="info" />
              </span>
            </template>
            {{ polygonTooltipInfo }}
          </v-tooltip>
        </div>
      </template>
    </div>
    <div class="address-filial-info-map">
      <address-map
        :loading="loading"
        :latitude="latitude"
        :longitude="longitude"
        :filial-id="polygonFilialId"
      />
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import Loader from '@/components/loader/Loader.vue'
  import WorkTimeLabel from '@/components/ui/WorkTimeLabel.vue'
  import PolygonType from '@/models/enums/PolygonType'
  import AddressMap from '@/components/order-processing/order-components/address-window/AddressMap.vue'
  import { mapGetters } from 'vuex'
  export default {
    name: 'AddressFilialInfo',
    components: { AddressMap, WorkTimeLabel, Loader },
    emits: ['choose-coordinates'],
    props: {
      info: {
        type: Object,
        default: null,
      },
      error: {
        type: String,
        default: '',
      },
      loading: {
        type: Boolean,
        default: false,
      },
      pointLat: {
        type: [String, Number],
        default: null,
      },
      pointLng: {
        type: [String, Number],
        default: null,
      },
    },
    computed: {
      ...mapGetters({
        indicateFilialConnectionStatus: 'app/indicateFilialConnectionStatus',
      }),
      filialIsNotConnected () {
        return this.indicateFilialConnectionStatus && this.polygonFilial?.isConnected === false
      },
      showChooseCoordinatesLink () {
        return this.coordinates && !this.info?.polygonId
      },
      errorText () {
        if (this.error) {
          return this.error
        }

        if (this.coordinates && !this.info?.polygonId) {
          return 'Данный адрес не входит ни в одну зону доставки.'
        }

        return null
      },
      coordinates () {
        if (this.info?.lat && this.info?.let) {
          return `(${this.info.lat}, ${this.info.let})`
        }
        return null
      },
      latitude () {
        return this.info?.lat ?? this.pointLat
      },
      longitude () {
        return this.info?.let ?? this.pointLng
      },
      polygonFilial () {
        return this.info?.filial || {}
      },
      polygonFilialId () {
        return this.polygonFilial?.id
      },
      polygonInfoLabel () {
        if (!_.isEmpty(this.info)) {
          const type = PolygonType.getName(this.info.type)
          return `${this.polygonFilial.name}, ${type} зона`
        }
        return ''
      },
      polygonDeliveryTime () {
        if (this.info?.timeInDelivery > 0) {
          return Math.floor(this.info?.timeInDelivery / 60) + ' минут,'
        }
        return null
      },
      polygonMinAmount () {
        return this.info?.minOrderPrice
      },
      polygonTooltipInfo () {
        return this.info?.polygonName
      },
      getFilialStartTime () {
        return this.polygonFilial?.startTime
      },
      getFilialEndTime () {
        return this.polygonFilial?.endTime
      },
      getFilialTimeZone () {
        return this.polygonFilial?.timeZone
      },
    },
  }
</script>

<style scoped lang="less">
.address-filial-info {
  border-radius: 10px;
  background-color: #fff3d6;
  padding: 0.7em 1.14em;
  font-size: 1.2em;
  margin-bottom: 20px;

  .choose-coordinates-btn {
    //color: @color-blue-corporate;
    margin-left: 30px;
  }

  &-loader {
    ::v-deep {
      div {
        width: 25px;
        height: 25px;
        margin: 0;
        border-width: 2px;
      }
    }
  }
  &-error {
    color: @color-pink;
    display: flex;
    align-items: center;
    justify-content: space-between;

    svg {
      margin-right: 10px;
      .fill-svg(@color-pink);
    }
  }

  &-hint {
    color: #5e5e5e;
  }

  &-block {
    display: flex;
    align-items: center;
  }

  &-work-time {
    margin-left: 20px;
  }

  &-alert {
    color: @color-pink;
    display: inline-block;
    padding: 1px 7px;
    font-size: 0.9rem;
    border: 1px solid @color-pink;
    border-radius: 100px;
    margin-left: 7px;
    position: relative;
    top: -2px
  }

  .polygon-info-icon {
    margin-left: 20px;
    border: 1px solid;
    border-radius: 50%;
    //padding: 3px;
    width: 2em;
    height: 2em;
    line-height: 1.8em;
    display: inline-block;
    text-align: center;
    font-size: 9px;
    top: -2px;
    position: relative;
    cursor: pointer;
    vertical-align: middle;
  }
}
</style>
